// AuditFilters.jsx — filter bar for AuditTable
import React from "react";

export default function AuditFilters({
  country,
  setCountry,
  year,
  setYear,
  onAddFinding,
  onImport,
  user,               // ✅ on récupère l’utilisateur pour vérifier son rôle
}) {
  const isAdmin = user?.user_type?.toLowerCase() === "admin";

  return (
    <div className="audit-filterbar">
      <h3 className="audit-title">Audit Findings – {country} ({year})</h3>

      <div className="audit-filterbar-right">
        <select
          className="form-select audit-select"
          value={country}
          onChange={(e) => setCountry(e.target.value)}
        >
          <option value="FR">France</option>
          <option value="DE">Germany</option>
          <option value="BE">Belgium</option>
          <option value="CH">Switzerland</option>
          <option value="US">United States</option>
          <option value="ES">Spain</option>
          <option value="IE">Ireland & UK</option>
          <option value="GR">Greece</option>
          <option value="IT">Italy</option>
        </select>

        <select
          className="form-select audit-select"
          value={year}
          onChange={(e) => setYear(e.target.value)}
        >
          {[2023, 2024, 2025, 2026].map((y) => (
            <option key={y} value={y}>{y}</option>
          ))}
        </select>

        <button type="button" className="audit-add-btn" onClick={onAddFinding}>
          Add Finding
        </button>

        {/* ✅ Import CSV disabled si non-admin */}
        <button
          type="button"
          className="audit-add-btn"
          onClick={isAdmin ? onImport : undefined}
          disabled={!isAdmin}
          title={isAdmin ? "Import CSV" : "Admins only"}
          style={!isAdmin ? { opacity: 0.6, cursor: "not-allowed" } : {}}
        >
          Import CSV
        </button>
      </div>
    </div>
  );
}
